import { setSpecificMessage, isoDate } from "valibot";
setSpecificMessage(
  isoDate,
  (issue) => `Date invalide: reçu ${issue.received}`,
  "fr"
);